import React, { useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { CalendarToday } from '@material-ui/icons';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  hideNativePicker: {
    '&::-webkit-calendar-picker-indicator': {
      display: 'none',
      WebkitAppearance: 'none',
    },
  },
}));

const styles = {
  container: {
    //border: '1px solid #e0e0e0',
    //borderRadius: '6px',
    margin: '10px 0px 14px 0px',
    padding: '10px 0px 14px 0px',
  },
  textfield: {
    width: '100%',
  },
};

export default function OneLineTextInputComponent(props) {
  const theme = useTheme();
  const classes = useStyles();
  const inputRef = useRef(null);
  const isDate = props.type === 'date';

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={styles.container}
    >
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          {props.label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={10} xl={10}>
        <TextField
          value={props.fieldvalue === null ? '' : props.fieldvalue}
          name={props.fieldname}
          style={styles.textfield}
          variant="outlined"
          type={props.type || 'text'}
          inputRef={inputRef}
          InputLabelProps={isDate ? { shrink: true } : undefined}
          InputProps={
            isDate
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        title="Apri selezione data"
                        onClick={() => {
                          if (inputRef.current) {
                            inputRef.current.focus();
                            try {
                              inputRef.current.showPicker();
                            } catch (_) {
                              // showPicker not supported
                            }
                          }
                        }}
                      >
                        <CalendarToday
                          fontSize="small"
                          style={{ color: theme.palette.primary.main }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : undefined
          }
          inputProps={
            isDate ? { className: classes.hideNativePicker } : undefined
          }
          onChange={(e) => props.onChangeEvent(e, props.fieldname)}
        />
      </Grid>
    </Grid>
  );
}

OneLineTextInputComponent.propTypes = {
  label: PropTypes.string.isRequired,
  fieldname: PropTypes.string.isRequired,
  fieldvalue: PropTypes.string,
  onChangeEvent: PropTypes.func.isRequired,
};
